module.exports = __webpack_public_path__ + "static/39-which-eu-countries-are-best-prepared-for-the-future-of-work-46dc15ceeeaf03fec1f5b27a01cec53d.jpg";